import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import ContentContainer from 'Components/UI/ContentContainer';
import { flexCenterColumn } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ImageContainer = styled.img`
  width: ${({ theme: { reference } }) => reference.dimension_128};
`;

export const Container = styled(FlexContainer)`
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
  height: 100%;
  ${flexCenterColumn}
`;

export const ValidationContent = styled(ContentContainer)`
  display: block;
  padding-top: 0;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    justify-content: flex-start;
  }
`;

export const ButtonsContainer = styled(FlexContainer)`
  background-color: ${({ theme: { system } }) =>
    system.background.fds_sys_color_background_secondary};
  margin-bottom: ${({ theme: { sizing } }) => sizing.fds_size_16};
  > button {
    width: ${({ theme: { reference } }) => reference.dimension_240};
  }
`;
